export default {
  width: 16,
  height: 16,
  viewBox: '0 0 14 24',
  data: '<path d="M12 22L2 12.03L12 2" stroke-width="2.5" stroke-linecap="round"/>'
}
